import { useEffect } from 'react';
import { join } from 'light-component';
import { Input } from 'antd';
import { useTranslation } from '../../../i18n';
import { Box } from '../../../box';
import { DragItem, Highlighter } from '../../component';
import styles from '../style.module.less';
import { service } from '../service';
import type { ReactElement } from 'react';
import type { ShotEyesAmountProps } from './types';

export function ShotEyesAmountDesignMode(props: ShotEyesAmountProps): ReactElement {
  const [t] = useTranslation();
  useEffect(() => {
    if (props.name !== '') {
      props?.onPropsChange?.({ title: t('ShotEyesAmount') });
    }
  }, [props.name]);

  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesAmount')} />
    );
  }
  return (
    <Box
      className={join(styles.designBox, { [styles.checkActive]: props.active === true })}
      style={{ paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <Input type='text' placeholder={props.textPlaceholder} />
      </Box>
    </Box>
  );
}
